import { put, takeLatest, call } from 'redux-saga/effects'

import * as orderService from '../../../services/orderService'
import {
  UNCANCEL_ORDER,
  UNCANCEL_ORDER_SUCCESS,
  UNCANCEL_ORDER_ERROR
}
  from '../../actions/order'

function * unCancelOrderSaga (action) {
  try {
    const data = yield call(orderService.UnCancelOrder, action.payload)

    yield put({
      type: UNCANCEL_ORDER_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: UNCANCEL_ORDER_ERROR, error: error.data
    })
  }
}

export function * unCancelOrderSagaWatcher () {
  yield takeLatest(UNCANCEL_ORDER, unCancelOrderSaga)
}
